import { tns } from './../../../node_modules/tiny-slider/src/tiny-slider';
import Swiper from 'swiper';
import { Navigation, Pagination, Mousewheel } from 'swiper';

export default class Sliders {
    constructor() {
        Swiper.use([ Navigation, Pagination, Mousewheel ]);

        this.sliderPush();
        this.sliderCard();
        this.sliderFull();
        this.sliderPartner();
    }

    sliderPush() {
        const elements = document.querySelectorAll('.push');
        if(elements.length > 0) {
            elements.forEach((elt) => {
                new Swiper(elt, {
                    loop: false,
                    slidesPerView: 1,
                    spaceBetween: 20,
                    freeMode: {
                        enabled: true,
                        sticky: false,
                        momentumBounce: false,
                    },
                    mousewheel: {
                        enabled: true,
                        sensitivity: 1,
                        forceToAxis: true,
                    },
                    pagination: {
                      el: '.swiper-pagination',
                      clickable: true,
                    },
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                    breakpoints: {
                        1023: {
                            slidesPerView: 3.5,
                        },
                        768: {
                            slidesPerView: 2.3,
                        }
                    }
                });
            });
        }
    }

    sliderPartner() {
        const elements = document.querySelectorAll('.partner');
        if(elements.length > 0) {
            elements.forEach((elt) => {
                new Swiper(elt, {
                    loop: false,
                    slidesPerView: 2,
                    spaceBetween: 60,
                    freeMode: {
                        enabled: true,
                        sticky: false,
                        momentumBounce: false,
                    },
                    mousewheel: {
                        enabled: true,
                        sensitivity: 1,
                        forceToAxis: true,
                    },
                    pagination: {
                      el: '.swiper-pagination',
                      clickable: true,
                    },
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                    breakpoints: {
                        1023: {
                            slidesPerView: 4,
                        },
                        768: {
                            slidesPerView: 3,
                        }
                    }
                });
            });
        }
    }

    sliderCard() {
        const elements = document.querySelectorAll('.card');
        if(elements.length > 0) {
            elements.forEach((elt) => {
                new Swiper(elt, {
                    loop: false,
                    slidesPerView: 1,
                    spaceBetween: 20,
                    freeMode: {
                        enabled: true,
                        sticky: false,
                        momentumBounce: false,
                    },
                    mousewheel: {
                        enabled: true,
                        sensitivity: 1,
                        forceToAxis: true,
                    },
                    pagination: {
                      el: '.swiper-pagination',
                      clickable: true,
                    },
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                    breakpoints: {
                        1023: {
                            slidesPerView: 3.5,
                        },
                        768: {
                            slidesPerView: 2.3,
                        }
                    }
                });
            });
        }
    }

    sliderFull() {
        const elements = document.querySelectorAll('.cardFull');
        if(elements.length > 0) {
            elements.forEach((elt) => {
                new Swiper(elt, {
                    loop: false,
                    slidesPerView: 1,
                    spaceBetween: 20,
                    mousewheel: {
                        enabled: true,
                        sensitivity: 1,
                        forceToAxis: true,
                    },
                    pagination: {
                      el: '.swiper-pagination',
                      clickable: true,
                    },
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                });
            });
        }
    }
}